import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Overflow16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.5 2.52174C9.5 3.36217 8.82843 4.04348 8 4.04348C7.17157 4.04348 6.5 3.36217 6.5 2.52174C6.5 1.68131 7.17157 1 8 1C8.82843 1 9.5 1.68131 9.5 2.52174ZM9.5 7.79715C9.5 8.63758 8.82843 9.31889 8 9.31889C7.17157 9.31889 6.5 8.63758 6.5 7.79715C6.5 6.95672 7.17157 6.27541 8 6.27541C8.82843 6.27541 9.5 6.95672 9.5 7.79715ZM8 15C8.82843 15 9.5 14.3187 9.5 13.4783C9.5 12.6378 8.82843 11.9565 8 11.9565C7.17157 11.9565 6.5 12.6378 6.5 13.4783C6.5 14.3187 7.17157 15 8 15Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
